<!--
 * @Date: 2022-09-13 19:19:03
 * @LastEditTime: 2022-10-19 14:44:41
 * @Description: 青心计划 活动规则
-->
<template>
  <div class="activity-rule">
    <div class="rule-icon" @click="onClickRule">
      <span>活</span>
      <span>动</span>
      <span>规</span>
      <span>则</span>
    </div>
    <div v-if="showRule" class="modal" @touchstart.self="onCloseRule">
      <div class="rule-wrapper">
        <div class="rule">
          <p class="title">活动规则</p>
          <p>一、活动奖品：累计活动金币前10名可以获得大奖，奖品如下：</p>
          <p>
            一等奖（1名）：1000元京东卡
          </p>
          <p>
            二等奖（2名）：鱼跃电子血压计（价值299元）
          </p>
          <p>
            三等奖（3名）：红豆热敷袋（价值99元）
          </p>
          <p>三等奖（4名）：南极人荞麦枕头（价值69元）</p>
          <p>
            *累计活动金币：通过本次活动赚取的金币数量总值，转盘抽奖和奖品兑换消耗金币不影响累计值
          </p>
          <p>*活动前3名的累计活动金币不低于5000才可以获奖，否则名次顺延</p>
          <p>*若累计活动金币相同，则以获得金币的时间顺序排序</p>

          <p>二、活动规则</p>
          <p>
            1）本次金币活动时间：10月25日-11月4日。本次活动赚取的金币有效期同活动时间；
          </p>
          <p>
            2）点击完成相关任务才可获得相关金币奖励；如违规完成相关任务，需扣除相应的金币（如发布不当评论、违规发帖），具体可到【我的金币】查看明细；
          </p>
          <p>
            3）若参与转盘抽奖、金币兑换问诊券等，优先消耗通过活动赚取的金币，消耗完后，再消耗日常赚取的金币；
          </p>
          <p>4）转盘抽奖：每次抽奖消耗50金币；</p>
          <p>
            5）转盘抽奖：若抽中实物奖励，需填写收货信息，实物奖品预计在15个工作日内寄出。注：未在活动期间及时填写收货信息，视为放弃；
          </p>
          <p>
            6）本活动解释权归春雨医生所有。如对本活动有疑问，请联系客服。
          </p>
          <p>三、金币获取规则</p>
          <p>
            1）社区发帖1次奖励100金币，单日上限2次；
          </p>
          <p>
            2）社区评论1次奖励20金币，单日上限5次；
          </p>
          <p>
            3）预约直播1次奖励20金币，单日上限2次；
          </p>
          <p>
            4）观看直播（单次观看时间不低于3分钟）1次奖励100金币，单日上限3次；
          </p>
          <p>
            5）直播评论1次奖励50金币，单日上限5次。
          </p>
        </div>
      </div>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/09/19/ea4e/ac274df3bb38_w105_h102_.png"
        alt=""
        class="close-icon"
        @click="onCloseRule"
      />
    </div>
  </div>
</template>

<script>
import { doPoint } from '@/utils/index';
import * as cyDetect from '@cy/detect';

export default {
  data() {
    return {
      showRule: false,
    };
  },
  methods: {
    /**
     * 打开规则
     */
    onClickRule() {
      this.showRule = true;
      const ele = document.getElementsByClassName('qingxin-task')[0];
      ele.style.position = 'fixed';
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '活动规则',
      });
    },
    /**
     * 关闭规则
     */
    onCloseRule() {
      const ele = document.getElementsByClassName('qingxin-task')[0];
      ele.style.position = 'relative';
      this.showRule = false;
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.activity-rule {
  .rule-icon {
    position: absolute;
    top: rem(106);
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    width: rem(24);
    height: rem(71);
    padding: rem(6) rem(7);
    color: #fff;
    font-weight: bold;
    font-size: rem(11);
    background: #ffa182;
    border-top-left-radius: rem(5);
    border-bottom-left-radius: rem(5);
  }
  .modal {
    position: fixed;
    top: 0;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }
  .close-icon {
    position: absolute;
    top: rem(557);
    left: rem(169);
    width: rem(37);
    height: rem(37);
  }
  .rule-wrapper {
    position: absolute;
    top: rem(200);
    left: rem(48);
    box-sizing: border-box;
    width: rem(280);
    height: rem(342);
    padding: rem(20) rem(24);
    background: #fff;
    border-radius: rem(4);
    .rule {
      height: 100%;
      overflow: scroll;
      line-height: rem(25);
    }
    .title {
      margin-bottom: rem(12);
      color: #1a1a1a;
      font-size: rem(18);
      text-align: center;
    }
    p {
      margin: 0;
      color: #666;
      font-size: rem(15);
    }
  }
}
</style>
